import { render, staticRenderFns } from "./filtered_search_and_sort.vue?vue&type=template&id=327e1f06"
import script from "./filtered_search_and_sort.vue?vue&type=script&lang=js"
export * from "./filtered_search_and_sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports